import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  menu: {
    padding: 0,
    width: 462,
  },
}));
